export const decodeToken = (token) => {
    if (!token) return null;

    try {
        const base64Url = token.split('.')[1]; // Obtém a parte do payload do token
        const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/'); // Converte para formato base64 válido
        const jsonPayload = decodeURIComponent(atob(base64).split('').map(c =>
            '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
        ).join(''));

        return JSON.parse(jsonPayload);
    } catch (error) {
        console.error("Erro ao decodificar o token:", error);
        return null;
    }
}
